import { useEffect } from 'react'
import { omit } from 'lodash'
import { FormikStringSchema, useClearOnUnmount, useFieldHelpers } from '@/base'
import { Textarea, TextareaProps } from '../../atoms/textarea'
import { FormField, FormFieldProps } from '.'

export const FormTextarea = (
  props: Omit<TextareaProps, 'onChange' | 'value'> &
    Omit<FormFieldProps, 'children'> & {
      onChangeCallback?: (_?: string) => void
      schema?: FormikStringSchema
      shouldClearOnDismount?: boolean
    }
) => {
  const { onChangeCallback, name, label, schema, shouldClearOnDismount } = props
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  useEffect(() => {
    if (onChangeCallback) {
      onChangeCallback(field.value)
    }
  }, [field.value, onChangeCallback])

  return (
    <FormField
      name={name}
      label={label}
      schema={schema}
      message={props.message}
      description={props.description}
      optionalText={props.optionalText}
    >
      <Textarea
        placeholder={typeof label === 'string' ? label : undefined}
        {...omit(props, ['onChangeCallback', 'validate'])}
        {...field}
        value={field.value ?? ''}
        onChange={(e) => helpers.setValue(e.target.value)}
      />
    </FormField>
  )
}
